import { useMemo } from 'react';
import { useParentalControls, ParentalSection } from '../contexts/ParentalControlsContext';

/**
 * Returns the ordered list of visible ContentNav item IDs for the current
 * parental-controls state. Kids mode hides non-kids sections; granular parental
 * blocks hide individual sections with lock UI elsewhere.
 */

const ALL_NAV_ITEMS: Array<{ id: string; section: ParentalSection }> = [
  { id: 'tv',     section: 'liveTV'  },
  { id: 'games',  section: 'sports'  },
  { id: 'movies', section: 'movies'  },
  { id: 'series', section: 'series'  },
  { id: 'kids',   section: 'kids'    },
  { id: 'anime',  section: 'anime'   },
];

export function useContentNavIds(): string[] {
  const { isNavVisible } = useParentalControls();
  return useMemo(
    () => ALL_NAV_ITEMS.filter((item) => isNavVisible(item.section)).map((item) => item.id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isNavVisible],
  );
}
